import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=689659da&scoped=true&lang=pug&"
import script from "./Personal.vue?vue&type=script&lang=ts&"
export * from "./Personal.vue?vue&type=script&lang=ts&"
import style0 from "./Personal.vue?vue&type=style&index=0&id=689659da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689659da",
  null
  
)

export default component.exports